import { Box, Typography } from "@mui/material";
import { ExternalLink } from "ExternalLink";
import { OLButton } from "OLButton";
import { hasViewAccessToResource } from "api/general";
import { ReactComponent as Download01Icon } from "components/Icons/download-01.svg";
import { ReactComponent as EmptySegmentIcon } from "components/Icons/emptySegmentIcon.svg";
import { useMessage } from "hooks/intl";
import { useStyles } from "./ImportCsv.styles";

interface Props {
  title: string;
  subtitle: string;
  guideLink: string;
  actionButtonText: string;
  importGuideButtonLabel?: string;
  openModal: () => void;
}

export const ImportCsv = ({
  title,
  subtitle,
  guideLink,
  actionButtonText,
  importGuideButtonLabel = "viewImportGuide",
  openModal,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const hasViewImportPermission = hasViewAccessToResource("IMPORT");

  return (
    <>
      <Box className={classes.gridContainer}>
        <Box className={classes.iconWrapper}>
          <EmptySegmentIcon className={classes.icon} />
        </Box>
        <Typography className={classes.title}>
          {message({ id: title })}
        </Typography>
        <Typography className={classes.subtitle}>
          {message({ id: subtitle })}
        </Typography>
        <Box className={classes.btnSection}>
          <ExternalLink path={guideLink}>
            <OLButton variant="outlined" data-test-id="import-guide-button">
              {message({ id: importGuideButtonLabel })}
            </OLButton>
          </ExternalLink>
          <OLButton
            variant="contained"
            onClick={openModal}
            data-test-id="import-button"
            disabled={hasViewImportPermission}
          >
            {message({ id: actionButtonText })}
          </OLButton>
        </Box>
        <ExternalLink path="https://help.openloyalty.io/imports-exports/imports/sample-import-files">
          <OLButton
            className={classes.sampleCsvBtn}
            data-test-id="sample-csv-file-button"
          >
            <Download01Icon />
            {message({ id: "sampleCsvFile" })}
          </OLButton>
        </ExternalLink>
      </Box>
    </>
  );
};
